import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      {/* Upper Footer — Gold Background */}
      <div
        className="text-gray-900 px-6 md:px-12 py-14"
        style={{
          background: "linear-gradient(135deg, #B8860B 0%, #DAA520 25%, #FFD700 50%, #DAA520 75%, #B8860B 100%)",
        }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
                alt="StarBookPrime"
                className="h-10 w-10 rounded-lg object-cover"
              />
              <span className="font-bold text-lg text-gray-900">
                StarBook<span className="text-amber-900">Prime</span>
              </span>
            </div>
            <p className="text-amber-900 text-sm leading-relaxed mb-5 font-medium">
              America&apos;s local marketplace connecting verified factories, buyers, and influencers in one powerful platform.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-facebook-fill", label: "Facebook" },
                { icon: "ri-instagram-line", label: "Instagram" },
                { icon: "ri-twitter-x-line", label: "Twitter" },
                { icon: "ri-youtube-line", label: "YouTube" },
                { icon: "ri-tiktok-line", label: "TikTok" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer"
                  style={{
                    background: "rgba(0,0,0,0.15)",
                    color: "#5C3D00",
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "rgba(0,0,0,0.35)";
                    (e.currentTarget as HTMLAnchorElement).style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "rgba(0,0,0,0.15)";
                    (e.currentTarget as HTMLAnchorElement).style.color = "#5C3D00";
                  }}
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Marketplace */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-amber-900 mb-4">
              <a href="#marketplace">Marketplace</a>
            </h4>
            <ul className="space-y-2.5">
              {["Electronics", "Fashion", "Home & Garden", "Beauty", "Sports & Fitness", "Overseas Buyers"].map((item) => (
                <li key={item}>
                  <Link
                    to="/marketplace"
                    className="text-sm font-medium transition-colors"
                    style={{ color: "#5C3D00" }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#1a0a00"; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#5C3D00"; }}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For Sellers */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-amber-900 mb-4">
              <a href="#sellers">For Sellers</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Start Selling", path: "/upload" },
                { label: "Factory Verification", path: "/upload" },
                { label: "Influencer Program", path: "/influencer" },
                { label: "Seller Resources", path: "/upload" },
                { label: "Recruitment", path: "/recruitment" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm font-medium transition-colors"
                    style={{ color: "#5C3D00" }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#1a0a00"; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#5C3D00"; }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-amber-900 mb-4">
              <a href="#support">Support</a>
            </h4>
            <ul className="space-y-2.5">
              {["Help Center", "Contact Us", "Shipping Info", "Returns & Refunds", "Safety Tips", "Report a Seller"].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-sm font-medium transition-colors"
                    style={{ color: "#5C3D00" }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#1a0a00"; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#5C3D00"; }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
            <button
              className="mt-5 flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-full transition-all cursor-pointer whitespace-nowrap"
              style={{
                background: "rgba(0,0,0,0.25)",
                color: "#fff",
                border: "1.5px solid rgba(0,0,0,0.3)",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.background = "rgba(0,0,0,0.45)";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.background = "rgba(0,0,0,0.25)";
              }}
            >
              <i className="ri-customer-service-2-line" />
              Live Chat
            </button>
          </div>
        </div>
      </div>

      {/* Lower Footer — Deeper Gold */}
      <div
        className="px-4 md:px-12 py-5"
        style={{ background: "#8B6914" }}
      >
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-yellow-100 text-center sm:text-left">
            &copy; 2026 StarBookPrime. All rights reserved. | USA Local Marketplace
          </p>
          <div className="flex items-center gap-2 flex-wrap justify-center">
            {["Visa", "MC", "PayPal", "Apple Pay", "Google Pay"].map((p) => (
              <span
                key={p}
                className="text-xs px-2 py-1 rounded font-semibold"
                style={{ background: "rgba(255,255,255,0.15)", color: "#FFF8DC" }}
              >
                {p}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-3 text-xs text-yellow-100 flex-wrap justify-center">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
